import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A tale about always-on DRM and web security",
  "description": "",
  "published": "2013-03-28T00:00:00.000Z",
  "redirect_from": ["/blog/a-tale-about-always-on-drm-and-web-security/swizec/6088"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2013/03/diablo-characters.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2013/03/diablo-characters.png",
          "alt": "Diablo characters (I'm the guy with the shield)",
          "title": "Diablo characters (I'm the guy with the shield)"
        }}></img></a></p>
    <p>{`Two days ago I was at a friend's place and wanted to show her what `}<a parentName="p" {...{
        "href": "http://www.blizzard.com/diablo3/?rhtml=y",
        "title": "Diablo III"
      }}>{`Diablo 3`}</a>{` looks like. She shows me minecraft, I show her Diablo. Everyone's happy.`}</p>
    <p>{`But nope.`}</p>
    <p>{`I run Diablo, I mash in my password because of `}<em parentName="p">{`course`}</em>{` you have to log in to play a game with yourself. What could possibly be more natural ... but okay, maybe I don't want my cat to mess with my characters and Blizzard doesn't want me stealing their game. Fair enough.`}</p>
    <blockquote>
      <p parentName="blockquote">{`"Oh hai thar! We noticed some suspicious activity on your account so we decided you have to verify you're you via `}<a parentName="p" {...{
          "href": "http://www.battle.net/",
          "title": "Battle.net"
        }}>{`Battle.net`}</a>{`. Here's a link to get you going"`}</p>
    </blockquote>
    <p>{`Really? All I did was try to login from a different IP. I'm at a friend's place damn it, this is a laptop, what if I wanted to play in a coffee shop or on a plane or a pterodactyl?`}</p>
    <p>{`Sigh, fine ... I click the link expecting I'll just have to login on Battle.net so they can confirm I also know how to login with a browser and supposedly am not hacking.`}</p>
    <p>{`Tap tap tap.`}</p>
    <blockquote>
      <p parentName="blockquote">{`"So, you want to give us some digits of a physical copy of a game even though the only game associated with your account is a digital-only copy of Diablo? Or do you want to try answering your `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/Knowledge-based_authentication",
          "title": "Knowledge-based authentication"
        }}>{`secret question`}</a>{`?"`}</p>
    </blockquote>
    <p>{`Well crap, this isn't just about logging in. I have just been forced to reset my password via a security question `}<em parentName="p">{`just because I tried to play a game at a friend's place!`}</em></p>
    <p>{`I try once. I try twice. I try three times. Nothing.`}</p>
    <p>{`This can happen when you choose random `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Security_question",
        "title": "Security question"
      }}>{`security questions`}</a>{` and don't always answer truthfully because, you know, social engineering. Usually I just mash my hand over the keyboard.`}</p>
    <blockquote>
      <p parentName="blockquote">{`"You have made too many attempts! Your account is now locked! Contact support."`}</p>
    </blockquote>
    <p>{`Oh okay! Right. I'm using the wrong account! I used `}<a parentName="p" {...{
        "href": "mailto:_swizec@swizec.com_"
      }}>{`_swizec@swizec.com_`}</a>{` for the Diablo3 beta, then was unable to recover it when I wanted the full game. The real account is `}<em parentName="p"><a parentName="em" {...{
          "href": "mailto:swizec+battle@swizec.com"
        }}>{`swizec+battle@swizec.com`}</a></em></p>
    <p>{`Let's try again.`}</p>
    <p>{`A few attempts later ... OH! The security question is different on this account. Fuck me.`}</p>
    <p>{`Yay, I'm in!`}</p>
    <p>{`After two round-trips via email, countless attempts at answering the security question, numerous fiddles with the password to get them all matching and fitting the security rules I am finally in.`}</p>
    <p>{`That's it. No `}<em parentName="p">{`Hey thanks`}</em>{`, no, `}<em parentName="p">{`You can go game now`}</em>{`, just a cold account dashboard.`}</p>
    <p>{`Close tab. Run game. Log in.`}</p>
    <blockquote>
      <p parentName="blockquote">{`"Your password is incorrect"`}</p>
    </blockquote>
    <p>{`Oh for fuck's sake! I mistyped my password ... twice ... consistently enough that they matched.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/03/diablo-massacre.png",
        "alt": "Diablo massacre",
        "title": "Diablo massacre"
      }}></img></p>
    <p>{`Sigh, now how do I change my password?`}</p>
    <blockquote>
      <p parentName="blockquote">{`"Okay, just give us your old password and you can change it"`}</p>
    </blockquote>
    <p>{`But I don't know the old password!`}</p>
    <p>{`Log out. Reset password. `}<em parentName="p">{`"You have made too many attempts! Your account is locked! Contact support.`}{`_`}{`_`}{`"`}</em></p>
    <p>{`Oh fuck me. Fine. I will contact support because this is getting silly and I am fed up with you mr. Battle.net!`}</p>
    <p>{`Clicky clicky through tens of questions trying to divert me from contacting a real person and making me solve my own problems. I battle it through like a champ and finally reach three options: Submit ticket, live chat, phone call.`}</p>
    <p>{`Live chat and phone call are currently offline. Well okay, it `}<em parentName="p">{`is`}</em>{` midnight and you are the European Blizzard support people so you're probably sleeping. Fine.`}</p>
    <p>{`I click Submit ticket.`}</p>
    <blockquote>
      <p parentName="blockquote">{`"Please login to your Battle.net account to submit tickets"`}</p>
    </blockquote>
    <p>{`_`}{`_`}{`ARGH!`}</p>
    <p>{`I threw the computer out the window and cried myself to sleep.`}</p>
    <p>{`Ok, in reality I carefully put the computer away after slamming it shut ever so gently, it's new you know, and watched a movie or something with my friend. Screw Diablo.`}</p>
    <p>{`Next day I got home and unlocked my account without a fuss. No hint of too many attempts, no complaints about suspicious activity. Nothing. Just worked.`}</p>
    <p>{`I'm confused. Yesterday my account was hacked and Terrible Things (tm) were going on, today everything is fine and you don't even warn me that a crazy amount of stupid was happening last night? Right ...`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=7e879824-058e-4579-a7d6-f7aa6c103042",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      